import * as React from 'react'

export const Undo2Icon = React.memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_undo2)'>
        <path
          d='M21.5718 17.9497C21.5718 12.1041 16.8229 7.35351 10.9781 7.35013C8.47083 7.44774 6.86773 8.09249 5.64313 8.94534C4.59434 9.67579 3.80384 10.56 2.91705 11.5498H6.57184C7.12412 11.5498 7.57233 11.998 7.57233 12.5503C7.57196 13.1023 7.1239 13.5493 6.57184 13.5493H1.57233C1.04523 13.5493 0.527451 13.37 0.139709 12.9825C-0.248022 12.5947 -0.428605 12.077 -0.42865 11.5498V6.55032C-0.42865 5.99804 0.0195536 5.54984 0.571838 5.54984C1.12412 5.54984 1.57233 5.99804 1.57233 6.55032V10.0528C2.41002 9.11713 3.33389 8.11725 4.50055 7.30472C6.07081 6.21114 8.05944 5.4572 10.9341 5.35062L10.9532 5.34915H10.9722C17.9243 5.34936 23.5714 10.9976 23.5714 17.9497C23.5713 18.5018 23.1244 18.95 22.5723 18.9502C22.0201 18.9502 21.5719 18.502 21.5718 17.9497Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_undo2'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
})

Undo2Icon.displayName = 'Undo2Icon'
